import { render, staticRenderFns } from "./supplier-transaction.vue?vue&type=template&id=c0168b08"
import script from "./supplier-transaction.vue?vue&type=script&lang=js"
export * from "./supplier-transaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports